import { Invoice } from '../../clients/quipli-service/invoice/invoice';
import { CheckedPaymentResponse } from '../../clients/quipli-service/payment/payment';
import { ReactNode, useEffect, useState } from 'react';
import { ConfirmModal } from '../../components/modal/confirm-modal';
import { convertToMoney, dineroSum } from '../../util/util';
import { Currency } from 'dinero.js';
import { checkInvoicePaymentStatus } from './payment-utils';

export const ConfirmPaymentModal = ({
  invoice,
  currency,
  onConfirm,
  onCancel,
}: {
  invoice: Invoice;
  currency: string;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const [checkedPayments, setCheckedPayments] = useState<CheckedPaymentResponse>();
  const [prompt, setPrompt] = useState<string>();
  const [additionalText, setAdditionalText] = useState<ReactNode | undefined>();

  useEffect(() => {
    setCheckedPayments(checkInvoicePaymentStatus(invoice));
  }, []);

  useEffect(() => {
    if (checkedPayments) {
      if (!checkedPayments.pending.length && !checkedPayments.suspicious.length) {
        onConfirm();
        return;
      }
      const pending = checkedPayments.pending.length ? (
        <>
          There is a pending transaction balance of{' '}
          {dineroSum(
            checkedPayments.pending.flatMap((p) =>
              p.invoicePayments.map((p) => convertToMoney(p.amount, currency as Currency)),
            ),
            currency as Currency,
          ).toFormat()}{' '}
          on this invoice.
          <br />
          Continuing may result in duplicate charges.
          <br />
        </>
      ) : (
        <></>
      );
      const suspicious = checkedPayments.suspicious.length ? (
        <>
          There are suspicious transactions on this invoice.
          <br />
          Continuing may result in a cardholder dispute or theft.
        </>
      ) : (
        <></>
      );
      setPrompt(`Are you sure you would like to proceed with payment?`);
      setAdditionalText(
        <>
          {pending} {suspicious}
        </>,
      );
    }
  }, [checkedPayments]);

  return prompt ? (
    <ConfirmModal
      onConfirm={onConfirm}
      close={onCancel}
      prompt={prompt}
      additionalText={additionalText}
      isOpen={!!prompt}
    />
  ) : (
    <></>
  );
};
